import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-table_expand_open",
  "use": "icon-table_expand_open-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-table_expand_open\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M12,12v3H11V12H8V11h3V8h1v3h3v1Zm5.5,7H5.5A1.5,1.5,0,0,1,4,17.5V5.5A1.5,1.5,0,0,1,5.5,4h12A1.5,1.5,0,0,1,19,5.5v12A1.5,1.5,0,0,1,17.5,19ZM5.5,5a.5.5,0,0,0-.5.5v12a.5.5,0,0,0,.5.5h12a.5.5,0,0,0,.5-.5V5.5a.5.5,0,0,0-.5-.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol